import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledScoreLinearProgress from 'components/organisms/Progress/ScoreLinearProgress/ScoreLinearProgress.styles';
import constants from 'helpers/constants';
import LinearProgress from 'components/atoms/Progress/LinearProgress/LinearProgress';
import Typography from 'components/atoms/Text/Typography/Typography';
import Tooltip from 'components/atoms/Tooltips/Tooltip/Tooltip';

const ScoreLinearProgress = React.forwardRef((props, ref) => {
  const {
    score,
    showPercentage,
    showEmpty,
    color,
    reverse,
    isLoading,
    LinearProgressProps,
    ...innerProps
  } = useComponentProps(props, 'ScoreLinearProgress');

  const value = Math.min(100, Math.floor(score));
  const scoreDef = constants.data.score.lookup(reverse ? (100 - Math.floor(score ?? 0)) : Math.floor(score ?? 0));

  return <StyledScoreLinearProgress ref={ref} {...innerProps} $value={value}>
    {(score > 0 || showEmpty || isLoading) ? <Tooltip title={!showPercentage ? `${Math.floor(score)}%` : null}>
      <LinearProgress variant="determinate"
                      value={value}
                      color={color ?? scoreDef?.color}
                      isLoading={isLoading}
                      {...LinearProgressProps}/>
    </Tooltip> : null}
    {showPercentage ? <Typography variant="caption" color="white" isLoading={isLoading}>
      {`${Math.floor(score)}%`}
    </Typography> : null}
  </StyledScoreLinearProgress>
});

ScoreLinearProgress.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  score: PropTypes.number,
  showPercentage: PropTypes.bool,
  showEmpty: PropTypes.bool,
  color: PropTypes.string,
  reverse: PropTypes.bool,
  isLoading: PropTypes.bool,
  LinearProgressProps: PropTypes.object
};

export default ScoreLinearProgress;
